import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { FiInstagram, FiFacebook, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-white pt-20 pb-10 border-t border-veloura-primary/30">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Brand */}
          <div className="col-span-1 lg:col-span-1 border-r border-veloura-primary/20 pr-6">
            <Link to="/" className="inline-block mb-6">
              <span className="font-serif text-3xl tracking-wider text-veloura-text block">VELOURA</span>
              <span className="text-xs tracking-[0.2em] uppercase text-veloura-accent">Lash Studio</span>
            </Link>
            <p className="text-veloura-muted text-sm leading-relaxed mb-6">
              Montreal's premier lash studio specializing in custom-designed extensions for the modern woman.
            </p>
            <div className="flex gap-4">
              <a href="#" className="p-2 bg-veloura-bg rounded-full text-veloura-accent hover:bg-veloura-accent hover:text-white transition-colors">
                <SafeIcon icon={FiInstagram} className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 bg-veloura-bg rounded-full text-veloura-accent hover:bg-veloura-accent hover:text-white transition-colors">
                <SafeIcon icon={FiFacebook} className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-serif text-lg mb-6 text-veloura-text">Explore</h4>
            <ul className="space-y-3">
              {['Services', 'Gallery', 'About Us', 'Pricing', 'FAQ'].map(item => (
                <li key={item}>
                  <Link to={`/${item.toLowerCase().replace(' ', '-')}`} className="text-veloura-muted hover:text-veloura-accent transition-colors text-sm">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-lg mb-6 text-veloura-text">Contact Us</h4>
            <ul className="space-y-4 text-sm text-veloura-muted">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-veloura-accent shrink-0 mt-0.5" />
                <span>1225 Rue Crescent<br/>Montreal, QC H3G 2B1(Demo)</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-veloura-accent shrink-0" />
                <span>(514) 555-1234(Demo)</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-veloura-accent shrink-0" />
                <span>hello@velouralashstudio.ca(Demo)</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-serif text-lg mb-6 text-veloura-text">Studio Hours</h4>
            <ul className="space-y-2 text-sm text-veloura-muted">
              <li className="flex justify-between border-b border-veloura-bg pb-2">
                <span>Mon - Fri</span>
                <span>10:00 AM - 7:00 PM</span>
              </li>
              <li className="flex justify-between border-b border-veloura-bg pb-2 pt-2">
                <span>Saturday</span>
                <span>9:00 AM - 5:00 PM</span>
              </li>
              <li className="flex justify-between pt-2">
                <span>Sunday</span>
                <span>Closed</span>
              </li>
            </ul>
          </div>

        </div>
        
        <div className="text-center pt-8 border-t border-veloura-primary/30 text-sm text-veloura-muted flex flex-col md:flex-row justify-between items-center gap-4">
          <p>&copy; {new Date().getFullYear()} Veloura Lash Studio. All rights reserved.Site by SixForge</p>
          <div className="flex gap-4">
            <Link to="#" className="hover:text-veloura-accent">Privacy Policy</Link>
            <Link to="#" className="hover:text-veloura-accent">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;